export default "__VITE_ASSET__BOcaux7A__"